enum DeliveryTypeEnums {
    // constant
    SPREAD = 0,
    INSTANT = 1,
}

export { DeliveryTypeEnums };
